export class Class {
  constructor(form) {
    if (form) {
      this.id = form.id;
      this.action = form.action;
      this.brandLogo = form.brandLogo;
      this.coachSelects = form.coachSelects;
      this.correlatedCourse = form.correlatedCourse;
      this.coverImage = form.coverImage || {};
      this.coverImage = {
        courseListPagePictureV2: form.coverImage.courseListPagePictureV2 || "", // 课程列表页图片
        courseDetailsPageHeader: form.coverImage.courseDetailsPageHeader || "", // 课程详情页头图
        recommendedPicturesOfHomeCourseV2: form.coverImage.recommendedPicturesOfHomeCourseV2 || "", // 首页课程推荐图片
        recommendedPicturesOfRelevantCourse: form.coverImage.recommendedPicturesOfRelevantCourse || "", // 相关课程推荐图片
        shareCardImage: form.coverImage.shareCardImage || "", // 分享卡片图片
        shareImage: form.coverImage.shareImage || "", // 分享长图
        // myCourseListPictures: "", // 我的课程列表页推荐图片
      };
      this.description = form.description;
      this.duration = form.duration;
      // this.level = form.level
      this.fileId = form.fileId;
      this.mediaLink = form.mediaLink;
      this.mediaSize = form.mediaSize;
      this.recommendEquipments = form.recommendEquipments;
      this.subBrand = form.subBrand;
      this.subTitle = form.subTitle;
      this.tags = form.tags;
      this.tips = form.tips;
      this.title = form.title;
      this.totalConsumption = form.totalConsumption;
      this.lowConsumption = this.totalConsumption ? form.totalConsumption.split('~')[0] : "";
      this.upConsumption = form.totalConsumption ? form.totalConsumption.split('~')[1].replace('千卡', '') : "";
      this.courseTypeId = form.courseTypeId;
      this.isWithPractice = form.isWithPractice === 0 ? 0 : 1; // 是否非跟练课程 0非跟 1跟练
      this.isShow = form.isShow === 0 ? 0 : 1; // 是否在列表页展示0不展示 1展示
    } else {
      this.clear();
    }
  }

  clear() {
    this.id = "";
    this.action = [];
    this.brandLogo = "";
    // this.coachSelectVO = {
    //   firstName: "",
    //   id: "",
    //   lastName: "",
    //   level: "",
    // };
    this.coachSelectVO = [{
      id: "",
      level: "",
      firstName: "",
      lastName: "",
    }];
    this.correlatedCourse = [];
    this.coverImage = {
      courseListPagePictureV2: "", // 课程列表页图片
      courseDetailsPageHeader: "", // 课程详情页头图
      recommendedPicturesOfHomeCourseV2: "", // 首页课程推荐图片
      recommendedPicturesOfRelevantCourse: "", // 相关课程推荐图片
      shareCardImage: "", // 分享卡片图片
      shareImage: "", // 分享长图
      // myCourseListPictures: "", // 我的课程列表页推荐图片
    };
    this.description = "";
    this.duration = "";
    this.isWithPractice = 1;
    this.isShow = 1;
    // this.level = ''
    this.fileId = "";
    this.mediaLink = "";
    this.mediaSize = "";
    this.recommendEquipments = [];
    this.subBrand = "";
    this.subTitle = "";
    this.tags = [];
    this.tips = "";
    this.title = "";
    this.totalConsumption = "";
    this.courseTypeId = "";
    this.lowConsumption = "";
    this.upConsumption = "";
  }
}
